import React from "react";
import Crypto from "../assets/p1.png";
import Quote from "../assets/p3.png";
import Movie from '../assets/p7.jpeg'
import Ideas from '../assets/p8.png'
import Diab from "../assets/p5.png";
import Home from '../assets/p6.png'
import Footer from "./Footer";
import Background from "./Background";

const ProjectCard = ({
  title,
  description,
  techStack,
  repoLink,
  liveLink,
  image,
}) => {
  return (
    <div className="max-w-sm rounded-lg overflow-hidden shadow-lg bg-white-200 text-black m-4 transform transition duration-500 hover:scale-105 hover:shadow-xl  hover:shadow-gray-500/50">
      <img
        className="w-full h-50 object-cover rounded-t-lg"
        src={image}
        alt={title}
      />
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">{title}</div>
        <p className="text-slate-700 text-base">{description}</p>
      </div>
      <div className="px-6 pt-4 pb-2">
        {techStack.map((tech, index) => (
          <span
            key={index}
            className="inline-block bg-gray-700 rounded-full px-3 py-1 text-sm font-semibold text-gray-300 mr-2 mb-2"
          >
            {tech}
          </span>
        ))}
      </div>
      <div className="px-6 py-4 flex justify-between items-center">
        <a
          href={repoLink}
          className="flex items-center bg-gray-700 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded transition duration-300"
        >
          <i className="fab fa-github mr-2"></i>View Repo
        </a>
        <a
          href={liveLink}
          rel="noreferrer"
          target="_blank"
          className="flex items-center bg-indigo-500 hover:bg-indigo-400 text-white font-bold py-2 px-4 rounded transition duration-300"
        >
          <i className="fas fa-arrow-right mr-2"></i>Live Demo
        </a>
      </div>
    </div>
  );
};

const Projects = () => {
  return (
    <Background>
      <div className="py-12 mt-8">
        <h2 className="text-black text-4xl sm:text-5xl text-center font-extrabold mt-2 pt-4 pb-4">
          My Projects
        </h2>
        <div className="flex flex-wrap justify-center">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              description={project.description}
              techStack={project.techStack}
              repoLink={project.repoLink}
              liveLink={project.liveLink}
              image={project.image}
            />
          ))}
        </div>
      </div>
      <Footer />
    </Background>
  );
};

const projects = [
  {
    title: "Cryptotracker Web-App",
    description:
      "Integrated APIs from 10+ cryptocurrency exchanges,Delivering real-time price updates, historical data, and market trends.Orchestrated the user interface design, focusing on intuitive navigation, responsive layouts..",
    techStack: ["MongoDB", "Express", "React", "Node.js"],
    repoLink: "https://github.com/Sivasanath06/CRYPTOTRACKER",
    liveLink: "https://crypto-tracker-pied-theta.vercel.app/",
    image: Crypto,
  },
  {
    title: "Movix App",
    description:
      "Discover real-time movies and TV shows with detailed information using The Movix App.This app offers a responsive and visually appealing user interface that adapts seamlessly to various screen sizes.",
    techStack: ["React","TailwindCSS"],
    repoLink: "https://github.com/Sivasanath06/Movix-App-main",
    liveLink: "https://movix-sigma-murex.vercel.app/",
    image: Movie,
  },
  {
    title: "Quote Generator Web",
    description:
      "Automatically generate a random quote from a pool of predefined quotes. Display the author's name along with the quote. Integrate with external APIs that provide a vast collection of quotes",
    techStack: ["HTML","CSS","JavaScript"],
    repoLink: "https://github.com/Sivasanath06/Quote_Generator",
    liveLink: "https://quote-generator-ivory-six.vercel.app/",
    image: Quote,
  },
  {
    title: "Real Estate Web App",
    description:
      "Integrated local real estate APIs for targeted property data, enhancing site relevance.eveloped customized search filters based on local preferences, improving user experience. Used user feedback to iterate and enhance site features, aligning with local market needs.",
    techStack: ["Node.js", "React","MongoDB","Express","TailwindCSS"],
    repoLink: "https://github.com/Sivasanath06/Real-Estate-E-commerce",
    image: Ideas,
  },
  {
    title: "Diabetes-prediction",
    description:
      "Developed a Machine Learning model utilizing CatBoost algorithm with grid search CV hyperparameter tuning for diabetes disease prediction. Conducted ablation study to determine the most effective techniques, revealing CatBoost as the optimal model with 92.88% test accuracy. Implemented the model into a web application using Flask framework for interactive User Interface (UI).",
    techStack: ["Machine-Learning", "Flask"],
    repoLink: "https://github.com/Sivasanath06/Diabetes-Prognosis-with-Flask-Web-App",
    image: Diab,
  },
  {
    title: "HOME AUTOMATION ",
    description:
      "ciency. Created a comprehensive blueprint for integrating smart devices, utilizing IoT protocols for seamless communication Created a centralized control interface, customized automation scenarios and optimized performance Continuously enhanced system through user feedback and iterative updates.",
    techStack: ["Arduino", "Embedded C","Firebase"],
    repoLink: "https://github.com/Sivasanath06/Home-Automation",
    image: Home,
  },
];

export default Projects;
